import React, { useState, useRef, useEffect, MouseEvent } from "react";
import ChatgptIcon from "../../assets/images/chartgpt-icon.gif";
import { CloseCircleFilled } from "@ant-design/icons";
import styles from "./ChatGpt.module.css";
import { getBaseChatGPTUrl, getToken } from "@/utils/constants";

interface Position {
    x: number;
    y: number;
}

const ChatGpt: React.FC = () => {
    const [position, setPosition] = useState<Position>({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState<boolean>(false);
    const [isHide, setIsHide] = useState<boolean>(false);
    const [showPopup, setShowPopup] = useState<boolean>(true);

    const dragRef = useRef<HTMLDivElement>(null);
    const dragStartPos = useRef<Position>({ x: 0, y: 0 });
    const mouseStartPos = useRef<Position>({ x: 0, y: 0 });

    // 处理鼠标按下事件 - 开始拖拽
    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>): void => {
        setIsDragging(true);
        mouseStartPos.current = { x: e.clientX, y: e.clientY };
        dragStartPos.current = { ...position };

        // 添加全局事件监听
        document.addEventListener('mousemove', handleMouseMove as any);
        document.addEventListener('mouseup', handleMouseUp as any);

        e.preventDefault();
    };

    // 处理鼠标移动事件 - 拖拽中
    const handleMouseMove = (e: MouseEvent): void => {
        if (!isDragging) return;

        const deltaX = e.clientX - mouseStartPos.current.x;
        const deltaY = e.clientY - mouseStartPos.current.y;

        setPosition({
            x: dragStartPos.current.x + deltaX,
            y: dragStartPos.current.y + deltaY
        });
    };

    // 处理鼠标抬起事件 - 结束拖拽
    const handleMouseUp = (): void => {
        setIsDragging(false);

        // 移除全局事件监听
        document.removeEventListener('mousemove', handleMouseMove as any);
        document.removeEventListener('mouseup', handleMouseUp as any);
    };

    // 组件卸载时清理事件监听
    useEffect(() => {
        return () => {
            document.removeEventListener('mousemove', handleMouseMove as any);
            document.removeEventListener('mouseup', handleMouseUp as any);
        };
    }, []);

    const handleClick = (): void => {
        if (isDragging) {
            return;
        }
        window.open(`${getBaseChatGPTUrl()}?token=${getToken()}&auth-provider=zzw-portal&r=${Math.random()}`);
    };

    // 鼠标事件处理
    const handleMouseOver = (): void => setIsHide(true);
    const handleMouseOut = (): void => setIsHide(false);

    const handleClosePopup = (e: MouseEvent): void => {
        e.stopPropagation();
        setShowPopup(false);
    };

    // 获取问候语
    const getTimeGreeting = (): string => {
        const hour = new Date().getHours();

        if (hour >= 4 && hour < 8) return "早上好";
        if (hour >= 8 && hour < 10) return "上午好";
        if (hour >= 10 && hour < 12) return "中午好";
        if (hour >= 12 && hour < 18) return "下午好";
        return "晚上好";
    };

    return (
        <div
            className={styles.draggableBox}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
        >
            <div
                ref={dragRef}
                className={styles.draggableIcons}
                style={{
                    transform: `translate(${position.x}px, ${position.y}px)`,
                    cursor: isDragging ? 'grabbing' : 'grab'
                }}
            >
                <div
                    className={`${styles.openIcon} ${styles.animatedContent} ${styles.slideIn}`}
                    onMouseDown={handleMouseDown}
                >
                    {showPopup && (
                        <div className={styles.popup}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                position: 'relative'
                            }}>
                                <div className={styles.popupTitle} style={{
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                    marginTop: '2px',
                                    color: '#000'
                                }}>
                                    {getTimeGreeting()}
                                </div>

                                <CloseCircleFilled
                                    className={styles.popupClose}
                                    style={{
                                        color: 'red',
                                        fontSize: '16px',
                                        position: 'absolute',
                                        top: '0px',
                                        right: '0px',
                                        cursor: 'pointer'
                                    }}
                                    onClick={handleClosePopup}
                                />
                            </div>

                            <div className={styles.popupInfo} style={{ fontSize: '15px', color: '#000' }}>
                                我是蜘蛛网AI智能汽车人，旨在为您办公增添效率和乐趣，我可以帮您处理维修及办公遇到的问题，快来试试吧！
                            </div>
                        </div>
                    )}

                    <div
                        className={styles.openIconImg}
                        onClick={handleClick}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === 'Enter' && handleClick()}
                    >
                        <img src={ChatgptIcon} alt="蜘蛛网" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatGpt;